module.exports = __webpack_public_path__ + "static/media/card-bg2-light@2x.98b04764.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_42/imgs/card-bg2-light@2x.png
// module id = 997
// module chunks = 0